export function underlineWords() {
  const rawWords = window.underlinedWords;
  const wordsToUnderline = Array.isArray(rawWords)
    ? rawWords
    : typeof rawWords === 'string'
    ? parseRawWordString(rawWords)
    : [];

  if (!wordsToUnderline.length) return;

  function parseRawWordString(value) {
    if (!value.trim()) {
      return [];
    }

    if (value.includes('<p') || value.includes('</p>')) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(value, 'text/html');

      const paragraphs = Array.from(doc.body.querySelectorAll('p'))
        .map((p) => p.textContent.trim())
        .filter(Boolean);

      if (paragraphs.length) {
        return paragraphs;
      }
    }

    if (value.includes(',')) {
      return value
        .split(',')
        .map((word) => word.trim())
        .filter(Boolean);
    }

    return value
      .split(/\r?\n|\s+/)
      .map((word) => word.trim())
      .filter(Boolean);
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  const wordRegex = new RegExp(
    `\\b(${wordsToUnderline.map(escapeRegExp).join('|')})\\b`,
    'gi'
  );

  // Wrap heading contents once so flex only has two items:
  // ::before + .heading__text
  document.querySelectorAll('.heading').forEach((heading) => {
    if (heading.querySelector(':scope > .heading__text')) return;

    const wrapper = document.createElement('b');
    wrapper.className = 'heading__text';

    while (heading.firstChild) {
      wrapper.appendChild(heading.firstChild);
    }

    heading.appendChild(wrapper);
  });

  function wrapWords(node) {
    if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue.trim()) return;

    const text = node.nodeValue;
    const matches = [...text.matchAll(wordRegex)];

    if (!matches.length) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    for (const match of matches) {
      const matchedText = match[0];
      const index = match.index;

      if (index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(text.slice(lastIndex, index))
        );
      }

      const b = document.createElement('b');
      b.className = 'underlined';
      b.textContent = matchedText;

      fragment.appendChild(b);

      lastIndex = index + matchedText.length;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(
        document.createTextNode(text.slice(lastIndex))
      );
    }

    node.replaceWith(fragment);
  }

  function traverse(element) {
    if (
      element.nodeType !== Node.ELEMENT_NODE ||
      ['SCRIPT', 'STYLE', 'NOSCRIPT', 'IFRAME', 'OBJECT', 'A'].includes(
        element.tagName
      )
    ) {
      return;
    }

    for (let child = element.firstChild; child; ) {
      const next = child.nextSibling;

      if (child.nodeType === Node.TEXT_NODE) {
        wrapWords(child);
      } else {
        traverse(child);
      }

      child = next;
    }
  }

  traverse(document.body);
}